import { parse } from 'tinyduration'
import Store from '@/vuex/store'
import Router from '@/router'
import Vue from 'vue'

export default {
    methods:{
        log: function(value)
        {
            if (process.env.VUE_APP_MODE !== 'development') return
            window.console.log(value)
        }
    }
}

export function parse_flight_offers_duration(duration)
{
    return parse(duration)
}

export function parse_flight_offers_date(date)
{

    let split = date.split('T'),
        day_number = split[0].split('-')[2],
        month_number = split[0].split('-')[1],
        year = split[0].split('-')[0],
        new_date = new Date(year, parseInt(month_number)-1, day_number),
        month_string = new_date.toLocaleString('default', { month: 'long' })


    if(split[1] && split[1].length > 5) split[1] = split[1].slice(0, -3) // rimuove i secondi (:00)

    // yyy-mm-dd to dd-mm-yyyy
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(split[0] + ' ' + split[1])

    let readable_datetime = [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('-') + ' ' + split[1]

        
    return {
        day: split[0],
        hour: split[1],
        day_number: split[0].split('-')[2],
        month_number: split[0].split('-')[1],
        year: split[0].split('-')[0],
        month_string: month_string,
        readable_datetime: readable_datetime,
    }
}

export function is_authenticated()
{
    let token = Store.state.token
    
    // se c'è un token in get ha la precedenza (quello nello state potrebbe essere scaduto)
    if(Router.history.current.query.token) token = Router.history.current.query.token

    // non ho trovato alcun token
    if(!token) return false

    // ho un token ma NON un'integrazione

    // implementazione cancellara -> integration nello state
    // if(!Store.state.integration || !Store.state.integration.integration) return false

    // implementazione livetravel -> integration solo nel config
    if(!Vue.prototype.$config || !Vue.prototype.$config.integration || !Vue.prototype.$config.integration.integration) return false

    return true
}

export function reverse_date(date){
    // yyyy-mm-dd to dd-mm-yyyy and viceversa
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(date)
    return [pad(d.getDate()), pad(d.getMonth()+1), d.getFullYear()].join('-')
}

export function custom_event(action, label, value, category){

  label = label || ''
  value = value || 0
  category = category || ''

  if(Vue.prototype.$gtm){

    let gtmPayload = {
      event: 'customEvent',
      category: (category)? category : 'ce',
      action: action,
      label: label,
      value: value,
    };

    Vue.prototype.$gtm.trackEvent(gtmPayload);

  }

  if(window.clarity) window.clarity("set", action, label)

  if(window.LogRocket) window.LogRocket.track(action)

}